// extracted by mini-css-extract-plugin
export default {"ChannelTypeLabelContainer":"ChannelTypeLabel_ChannelTypeLabelContainer__0JV-X"};